<template>
  <img src="/images/promo/hero-section/email.png"
    alt="Email" />
</template>

<script>
export default {};
</script>
